import Axios from "axios";
import { ServiceUrl } from "../utils/serviceUrl";

export const listSettingsFields = async (encode = false, withFull = false) => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMIN.SETTINGS;
    if (encode) url += "?sta=1";
    Axios.get(url)
      .then(function ({ data }) {
        if (withFull) resolve(data);
        else resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listCommunity = async () => {
  return new Promise((resolve, reject) => {
    Axios.get(ServiceUrl.ADMIN.LIST_COMMUNITY)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listReligions = async () => {
  return new Promise((resolve, reject) => {
    Axios.get(ServiceUrl.ADMIN.LIST_RELIGIONS)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listScholarships = async () => {
  return new Promise((resolve, reject) => {
    Axios.get(ServiceUrl.ADMIN.LIST_SCHOLARSHIPS + "?status=1")
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};
